import { createFileRoute } from '@tanstack/react-router';

import { ContentEditor } from '../../../@components/content-editor/ContentEditor';
import { medicationUpdateEditorSettings } from '../../../@components/content-editor/medicationUpdateEditorSettings';

export const Route = createFileRoute(
  '/_layout/(private)/my-medications/$id/edit/',
)({
  component: MyMedicationsEditDetails,
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(
      medicationUpdateEditorSettings.detailsQueryOptions(params.id),
    );
  },
});

function MyMedicationsEditDetails() {
  const { id } = Route.useParams();

  return <ContentEditor id={id} settings={medicationUpdateEditorSettings} />;
}
